// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-9de319dc] .el-table thead.is-group th{background:#fafafa}[data-v-9de319dc] .el-form-item--small.el-form-item{margin-bottom:18px!important}.bg-white[data-v-9de319dc]{background-color:#fff!important}.cards[data-v-9de319dc]{background:#fff;padding:15px 10px 0 10px!important;padding-right:0!important;margin-bottom:15px}.ft500[data-v-9de319dc]{font-weight:700}", ""]);
// Exports
module.exports = exports;
